export enum PermissionRuleName {
  DashboardPage = 'page:dashboard',
  ReportsPage = 'page:reports',
  ResourceManagementPage = 'page:resource-management',
  TimesheetPage = 'page:timesheet',
  TemplatePage = 'page:template',
  BillingPage = 'page:settings:billing',
  TeamMemberSettingPage = 'page:settings:team-member',
  OrganisationSettingsPage = 'page:settings:organisation',
  HolidayCalendarSettingsPage = 'page:settings:holiday-calendar',
  PartnerSettingPage = 'page:settings:partner',
  RoleSettingPage = 'page:setting:role',
  CustomDomainSettingPage = 'page:setting:custom-domain',
  EmailConfigurationSettingPage = 'page:setting:email-configuration',
  SecuritySettingPage = 'page:setting:security',
  IntegrationSettingPage = 'page:setting:integration',
  TimesheetSettingPage = 'page:setting:timesheets',
  ResourceManagementSettingPage = 'page:setting:resource-management',
  AdvancedSettingPage = 'page:setting:advanced',
  ProjectFieldSettingPage = 'page:setting:project-field',
  TaskFieldSettingPage = 'page:setting:task-field',
  TeamMemberFieldSettingPage = 'page:setting:team-member-field',
  CustomerPortalSettingPage = 'page:setting:customer-portal-notification',
  ProjectCreateAction = 'action:project:create',
  ProjectViewAsCustomerAction = 'action:project:view-as-customer',
  ProjectChangeTabVisibilityAction = 'action:project:change-tab-visibility',
  ProjectOverviewPage = 'page:project:overview',
  ProjectFinancialsPage = 'page:project:financials',
  ProjectPlanPage = 'page:project:plan',
  ProjectSpacesPage = 'page:project:spaces',
  ProjectFormResponsePage = 'page:project:form-responses',
  ProjectStatusUpdatePage = 'page:project:status-update',
  ProjectHoursSection = 'section:project:project-hours',
  ProjectGoalsSection = 'section:project:business-goals',
  ProjectPlannedVsActualSection = 'section:project:planned-vs-actual',
  ProjectFieldsInOverviewSection = 'section:project:overview-fields',
  ProjectNativeMoneyFieldSection = 'section:project-field:money-field',
  ProjectCustomFieldSection = 'section:project-field:custom-field',
  ProjectPhaseCreateAction = 'action:project-phase:create',
  ProjectPhaseEditAction = 'action:project-phase:edit',
  ProjectPhaseAddTasksAction = 'action:project-phase:add-tasks',
  ProjectExportPrivateResourceAction = 'action:project:export-private-tasks',
  ProjectPhaseRearrangeTasksAction = 'action:project-phase:rearrange-tasks',
  StatusUpdateCreatePrivateAction = 'action:status-update:create-private',
  StatusUpdateCreateAction = 'action:status-update:create',
  FileGroupCreateAction = 'action:file:group-create',
  FilePrivateGroupCreateAction = 'action:file:private-group-create',
  FileUploadAction = 'action:file:update',
  FormResponseEditAction = 'action:form-response:edit',
  FormResponseDeleteAction = 'action:form-response:delete',
  ProjectChatCreateAction = 'action:project-chat:create',
  ProjectChatPrivateCreateAction = 'action:project-chat:private-create',
  ProjectChatDeleteAction = 'action:project-chat:delete',
  ProjectChatEditAction = 'action:project-chat:edit',
  SpacePrivateSection = 'section:space:private',
  SpaceSharedCreateAction = 'action:space:shared-create',
  SpaceSharedEditAction = 'action:space:shared-edit',
  SpaceSharedDeleteAction = 'action:space:shared-delete',
  SpaceSharedDocumentCreateAction = 'action:space:shared-document-create',
  SpaceSharedDocumentDeleteAction = 'action:space:shared-document-delete',
  SpaceSharedDocumentRearrangeAction = 'action:space:shared-document-rearrange',
  SpaceDocumentInsertPrivateSectionAction = 'action:space:insert-private-section',
  SpaceDocumentFreezeAction = 'action:space:document-freeze',
  CommentPrivateMessageCreateAction = 'action:comment:private-message-create',
  ApprovalPrivateCreateAction = 'action:approval:private-create',
  TaskCreateAction = 'action:task:create',
  TaskDeleteAction = 'action:task:delete',
  TaskNameEditAction = 'action:task-name:edit',
  TaskChangePrivacyAction = 'action:task:change-privacy',
  TaskMoveBetweenPhaseAction = 'action:task:move',
  TaskDuplicateAction = 'action:task:duplicate',
  TaskPrivateDescriptionSection = 'section:task:private-description',
  TaskAddDependentTaskAction = 'action:task:add-dependent-task',
  TaskRemoveDependentTaskAction = 'action:task:remove-dependent-task',
  TaskCsatSection = 'section:task:csat',
  TaskCreateJiraIssueAction = 'action:task:create-jira-issue',
  ProjectSettingDetailPage = 'page:project:detail-settings',
  ProjectSettingVisibilityPage = 'page:project:visibility-settings',
}
